import * as angular from 'angular';
import * as _ from 'underscore';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { AvatarService } from '../../../app.common/modules/common/services/avatar.service';
import { BlobService } from '../../../app.common/modules/common/services/blob.service';
import { RetailerService } from '../api/retailer.service';
import {
    JispPayMerchantListItem,
    SalesAssistant,
    SalesAssistantPagingResult,
    StoreJispPay,
    StoreJispPayEnable,
    StoreJispPayPagingResult
} from '../core';
import { IStoreForShopingListItem } from '../store-managers/models';
import {
    IPaginationjisppayStaffFilter,
    ISalesAssistantListItem
} from './models';
import { ICompanyInformation } from './models/ICompanyInformation';

export class JispPayService {
    public static $inject = [
        'http',
        'blobService',
        'retailerService',
        '$httpParamSerializer',
        '$uibModal',
        'avatarService'
    ];

    private jispPayMerchants: JispPayMerchantListItem[] = [];

    constructor(
        private http: HttpService,
        private blobService: BlobService,
        private retailerService: RetailerService,
        private $serializer: ng.IHttpParamSerializer,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private avatarService: AvatarService
    ) {}

    public getPlaces(offset?: number, limit?: number) {
        return this.http.get<StoreJispPayPagingResult>(
            this.retailerService.jisppayPlaces(offset, limit)
        );
    }

    public setPlace(id: number, model: StoreJispPay) {
        return this.http.put<void>(
            this.retailerService.jisppayPlace(id),
            model
        );
    }

    public setJispPayEnable(model: StoreJispPayEnable) {
        return this.http.put<void>(this.retailerService.jispPayEnable(), model);
    }

    public getJispPayMerchants = async () => {
        this.jispPayMerchants = await this.http.get<JispPayMerchantListItem[]>(
            this.retailerService.jispPayMerchants()
        );
        return this.jispPayMerchants;
    }

    public getDefaultMerchants() {
        return this.http.get<JispPayMerchantListItem[]>(
            this.retailerService.jispPayDefaultMerchants()
        );
    }

    public isStaffAny(isActive: boolean) {
        return this.http.get<boolean>(
            this.retailerService.jisppayStaffAny(isActive)
        );
    }

    public getStaff(filter: IPaginationjisppayStaffFilter) {
        return this.http.get<SalesAssistantPagingResult>(
            this.retailerService.jisppayStaff(),
            { params: filter }
        );
    }

    public getAvatarUrl(id: number, width?: number, height?: number) {
        const baseUrl = this.retailerService.jisppayStaff();
        const params = this.$serializer({ id, width, height });
        return `${baseUrl}/avatar?${params}`;
    }

    public getAvatarUploadUrl() {
        return  this.retailerService.jisppayUploadAvatar();
    }

    public createStaff(staff: SalesAssistant) {
        return this.http.post<number>(
            this.retailerService.jisppayAccount(),
            staff
        );
    }

    public updateStaff(id: number, staff: SalesAssistant) {
        return this.http.put<void>(
            this.retailerService.jisppayAccount(id),
            staff
        );
    }

    public archiveStaff(ids: number[]) {
        return this.http.delete<void>(this.retailerService.jisppayAccount(), {
            params: { id: ids }
        });
    }

    public restoreStaff(ids: number[]) {
        return this.http.post<void>(
            this.retailerService.jisppayAccountRestore(),
            ids
        );
    }

    public jisppayStaffLoginExist(email: string) {
        return this.http.get<boolean>(
            this.retailerService.jisppayStaffLoginExist(email)
        );
    }

    public getColumnSort(name?: string, isAsc?: boolean) {
        return {
            column: name ? name : 'ID',
            order: 'ascending',
            asc: 'ascending',
            desc: 'descending',
            isAsc: _.isUndefined(isAsc) ? true : isAsc,
            set: function(name: string, isAsc: boolean) {
                if (_.isUndefined(isAsc)) {
                    this.isAsc = !this.isAsc;
                } else {
                    this.isAsc = isAsc;
                }
                this.column = name ? name : 'ID';
                this.order = this.isAsc ? this.asc : this.desc;
            },
            sort: function(list: any[], field: string, asc: boolean) {
                return asc
                    ? _.sortBy(list, field)
                    : _.sortBy(list, field).reverse();
            },

            isSelected: function(field: string) {
                return this.column === field;
            }
        };
    }

    public uploadImage(file: any, url: string = null): Promise<number> {
        return this.avatarService.uploadImage(file, url ? url : this.retailerService.jisppayUploadAvatar());
    }

    public trim(str: string) {
        return str ? str.trim() : '';
    }

    public openAccountManager = (
        staff: ISalesAssistantListItem,
        places: IStoreForShopingListItem[]
    ) => {
        return this.$uibModal.open({
            component: 'jispPayAccount',
            resolve: {
                staff: () => staff,
                places: () => places
            },
            size: 'lg',
            windowClass: 'staffPopup',
            backdrop: 'static'
        }).result;
    }

    // public openVendorEditor = (places: IStoreForShopingListItem[], account?: IVendorTableItem) => {
    //     return this.$uibModal.open({
    //         component: 'addOrEditVendorItem',
    //         resolve: {
    //             vendorId: () => account ? account.ID : null,
    //             places: () => places
    //         },
    //         size: 'lg',
    //         windowClass: 'staffPopup',
    //         backdrop: 'static'
    //     }).result;
    // }

    public passwordConfirmation(id: number) {
        return this.$uibModal.open({
            component: 'passwordConfirmation',
            size: 'sm',
            windowClass: 'jisppayPopup jisppayPopupSmaller'
        }).result;
    }

    public getCompanyInfo() {
        return this.http.get<ICompanyInformation>(
            this.retailerService.companyInfoUrl()
        );
    }

    public putCompanyInfo(model: ICompanyInformation) {
        return this.http.put<ICompanyInformation>(
            this.retailerService.companyInfoUrl(),
            model
        );
    }
}

angular.module('naut').service('jispPayService', JispPayService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/jispPay.service.ts